var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8538 15.8563H13.3909V11.9981C13.3909 11.0776 13.3717 9.89356 12.107 9.89356C10.8232 9.89356 10.6269 10.8947 10.6269 11.9299V15.8563H8.16488V7.92125H10.5297V9.0022H10.5621C10.8922 8.37857 11.6963 7.72169 12.8969 7.72169C15.3923 7.72169 15.8538 9.36307 15.8538 11.5009V15.8563ZM5.38268 6.83531C4.58943 6.83531 3.9525 6.19422 3.9525 5.40513C3.9525 4.61603 4.59026 3.97495 5.38268 3.97495C5.76199 3.97495 6.12576 4.12563 6.39397 4.39384C6.66218 4.66205 6.81286 5.02582 6.81286 5.40513C6.81286 5.78444 6.66218 6.14821 6.39397 6.41642C6.12576 6.68463 5.76199 6.83531 5.38268 6.83531ZM6.61662 15.8571H4.14707V7.92125H6.61662V15.8571ZM17.086 1.685H2.91229C2.23379 1.685 1.685 2.22132 1.685 2.88236V17.1176C1.685 17.7787 2.23379 18.315 2.91229 18.315H17.0827C17.7604 18.315 18.315 17.7795 18.315 17.1176V2.88236C18.315 2.22215 17.7604 1.685 17.0827 1.685H17.086Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d99f4a80d1943cb062904dff1d47eac5.svg";
export { ForwardRef as ReactComponent };